import * as React from 'react';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid2";
import france from '../media/france.jpg';
import thailand from '../media/thailand.jpg';
import singapore from '../media/singapore.jpg';
import vietnam from '../media/vietnam.jpg';
import cruise from '../media/cruise.jpg';
import switzerland from '../media/switzerland.jpg';
import dubai from '../media/dubai.jpg';
import Typography from "@mui/material/Typography";

export default function Destinations() {
    return (
        <Box id="destinations" sx={{ flexGrow: 1, marginTop: '15px' }}>
            <Grid container spacing={2}>
                <Grid size={12}>
                    <Typography sx={{ color: 'gold', display: 'flex', alignItems: 'center' }} variant="h5" component="h5">
                        <hr className="middle-line" /> DESTINATION
                    </Typography>
                    <Typography sx={{  color: '#000', marginTop: '15px' }} variant="h5" gutterBottom>
                        Our Most Popular Travel Destination Tours
                    </Typography>
                </Grid>
                {itemData.map((item) => (
                    <Grid key={item.img} size={item.boxSize}>
                        <ImageListItem sx={{ height: '350px !important' }}>
                            <img
                                srcSet={`${item.img}`}
                                src={`${item.img}`}
                                alt={item.title}
                            />
                            <ImageListItemBar
                                title={item.title}
                            />
                        </ImageListItem>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
}

const itemData = [
    {
        img: france,
        title: 'France',
        tourCount: 5,
        boxSize: 3,
    },
    {
        img: thailand,
        title: 'Thailand',
        tourCount: 5,
        boxSize: 6,
    },
    {
        img: singapore,
        title: 'Singapore',
        tourCount: 5,
        boxSize: 3,
    },
    {
        img: vietnam,
        title: 'Vietnam',
        tourCount: 5,
        boxSize: 3,
    },
    {
        img: cruise,
        title: 'Cruise',
        tourCount: 5,
        boxSize: 3,
    },
    {
        img: switzerland,
        title: 'Switzerland',
        tourCount: 5,
        boxSize: 3,
    },
    {
        img: dubai,
        title: 'Dubai',
        tourCount: 5,
        boxSize: 3,
    },
];
